<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side.md
          side-nav(
            v-bind:sideNavData="sideNavData"
          )
        .profile-page__main.md
          .profile-page__header
            //.profile-page__title
              h1.title Аналитика
            .profile-page__tabs
              tab-nav(
              v-bind:tabNavData="tabNavData"
              )
            .profile-page__content
              section.form__elem--align-justify.form__elem_full.profile__filter
                .profile__table-filter
                  .simple-select-form
                    .simple-select-form__button Лагерь
                    //.simple-select-form__list
                      ul
                        li Лагерь
                        li Лагерь
                  .simple-select-form
                    .simple-select-form__button Смена
                    //.simple-select-form__list
                      ul
                        li Смена
                        li Смена
                .button.button_paint-main--transparent
                  .button__text Построить диаграмму
          .profile-page__body
            p Динамика рассмотрения
            .chart
              .chart__body
                chart()
                .chart__info
                  strong.number 1 005
                  br
                  span.text Заявок
              .chart__legend
                ul
                  li
                    .point(style="background: #F5A623")
                    .text Отклонено
                      span 23
                  li
                    .point(style="background: #FF4B78")
                    .text Отказ подающего
                    span 32
                  li
                    .point(style="background: #B3A0DC")
                    .text Оформлена
                    span 75

    .profile-page__footer.page__footer
      main-footer
</template>
<script>
import {mapState, mapActions} from "vuex";
import {Bar} from "vue-chartjs";

import MainFooter from "@/components/footer/Footer";
import SideNav from "@/components/sideNav/SideNav";
import TabNav from "../../../../components/tabNav/TabNav.vue";
import Chart from "../components/Chart.vue";

export default {
  name: "AnalyticsCharts",
  components: {
    Chart,
    TabNav,
    SideNav,
    MainFooter
  },
  props: ["sideNavData"],
  data() {
    return {
      tabNavData: {
        tabs: [
          {
            path: "/pages/analytics/charts",
            text: "Диаграммы"
          },
          {
            path: "/pages/analytics/reports",
            text: "Отчеты"
          }
        ]
      }
    };
  }
};
</script>
